import { formatBusinessDateTimeFromIso } from '@nudool/shared';
import { CalendarIcon, RotateCcwClockIcon } from 'lucide-react';

import type { DimeCardShellActivity } from '../DimeCardShell.js';
import type { DimeCardShellMetaItem } from '../DimeCardShellMeta.js';

function withActor(formatted: string | null, actor: string | null | undefined) {
  return formatted && actor ? `${formatted} by ${actor}` : formatted;
}

export function buildActivityMetaItems(
  activity: DimeCardShellActivity | undefined,
): DimeCardShellMetaItem[] {
  return [
    {
      icon: <CalendarIcon />,
      label: 'Created',
      value: withActor(formatBusinessDateTimeFromIso(activity?.created), activity?.createdBy),
    },
    {
      icon: <RotateCcwClockIcon />,
      label: 'Updated',
      value: withActor(formatBusinessDateTimeFromIso(activity?.updated), activity?.updatedBy),
    },
  ].filter((item) => item.value !== null);
}
